'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Reviews = exports.Banner = undefined;
var _jsxFileName = 'src/index.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _banner = require('./banner');
var _banner2 = _interopRequireDefault(_banner);
var _reviews = require('./reviews');
var _reviews2 = _interopRequireDefault(_reviews);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/* eslint-diable no-console */

exports.default = function (props) {
  console.warn('Using the trust pilot banner as a default import has been dprecated. Please import Banner as a named import instead.');
  return _react2.default.createElement(_banner2.default, Object.assign({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  }));
};
exports.Banner = _banner2.default;
exports.Reviews = _reviews2.default;